/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { deviceIntegrationsGetFleetCoverage } from "../funcs/deviceIntegrationsGetFleetCoverage.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { FleetCoverage } from "../models/components/fleetcoverage.js";
import {
  GetFleetCoverageRequest,
  GetFleetCoverageSecurity,
} from "../models/operations/getfleetcoverage.js";
import { unwrapAsync } from "../types/fp.js";
export type FleetCoverageQueryData = FleetCoverage;

export function prefetchFleetCoverage(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetFleetCoverageRequest | undefined,
  security?: GetFleetCoverageSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildFleetCoverageQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildFleetCoverageQuery(
  client$: GramCore,
  request?: GetFleetCoverageRequest | undefined,
  security?: GetFleetCoverageSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<FleetCoverageQueryData>;
} {
  return {
    queryKey: queryKeyFleetCoverage({
      provider: request?.provider,
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
    }),
    queryFn: async function fleetCoverageQueryFn(
      ctx,
    ): Promise<FleetCoverageQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(deviceIntegrationsGetFleetCoverage(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyFleetCoverage(
  parameters: {
    provider?: string | undefined;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "deviceIntegrations", "getFleetCoverage", parameters];
}
